import { EChatType } from '../types/app-chat.type';

export const ChatTypeMap = {
  [EChatType.PRIVATE]: {
    name: 'Private Chat',
  },
  [EChatType.OWN_COMPANY]: {
    name: 'Your Company Chat',
  },
  [EChatType.CUSTOMER]: {
    name: 'Customer Chat',
  },
  [EChatType.COMPANY_COMPANY]: {
    name: 'Company Chat',
  },
};
